<template>
  <v-container fluid fill-height>
    <v-layout align-start justify-center>
      <v-flex xs12 sm10 md8 lg8 xl5>
        <v-card class="elevation-12">
          <v-toolbar dark color="primary">
            <v-toolbar-title>Dzienniczek treningowy</v-toolbar-title>
          </v-toolbar>
          <form class="login" @submit.prevent="login" novalidate>
          <v-card-text>
            <v-alert
              :value="validation.hasError('userCredentials.non_field_errors')"
              type="error"
            >
              <span v-for="error in validation.allErrors('userCredentials.non_field_errors')">{{error}}</span>
            </v-alert>
              <v-text-field
                prepend-icon="person"
                v-model="userCredentials.email"
                :error-messages="validation.allErrors('userCredentials.email')"
                name="login"
                label="E-mail"
                type="text"></v-text-field>
              <v-text-field
                prepend-icon="lock"
                v-model="userCredentials.password"
                :error-messages="validation.allErrors('userCredentials.password')"
                name="password"
                label="Hasło"
                id="password"
                type="password"></v-text-field>
          </v-card-text>
            <v-layout row wrap justify-space-between>
            <v-flex xs12 sm9>
              <v-btn color="accent" flat :to="{name: 'register-self'}">Zarejestruj się</v-btn>
              <v-btn color="grey darken-1" flat :to="{name: 'password-reset'}">Nie pamiętasz hasła?</v-btn>
            </v-flex>
            <v-flex xs12 sm3 class="text-md-right">
              <v-btn type="submit" color="primary">Zaloguj</v-btn>
            </v-flex>
            </v-layout>
          </form>
          <v-progress-linear v-if="progress" :indeterminate="true"></v-progress-linear>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import * as types from '@/store/mutation-types'
import {Validator} from 'simple-vue-validator'
import {serverValidation} from '@/utils/form-utils'

export default {
  validators: {
    'userCredentials.email': function (value) {
      return Validator.value(value).required().custom(serverValidation(this.formErrors, 'email'))
    },
    'userCredentials.password': function (value) {
      return Validator.value(value).required().custom(serverValidation(this.formErrors, 'password'))
    },
    'userCredentials.non_field_errors': function (value) {
      return Validator.value(value).custom(serverValidation(this.formErrors, 'non_field_errors'))
    }
  },
  data () {
    return {
      userCredentials: {
        email: '',
        password: ''
      },
      progress: false,
      formErrors: []
    }
  },
  methods: {
    login: function () {
      this.$validate().then(success => {
        if (success) {
          this.progress = true
          this.$store.dispatch(types.AUTH_REQUEST, this.userCredentials).then(() => {
            this.$router.push({name: 'app'})
          }).catch((data) => {
            if (data.response.status === 400) {
              this.formErrors = data.response.data
              this.$validate()
            }
          }).finally(() => {
            this.progress = false
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/auth/Login.vue